export default __webpack_public_path__ + "static/media/04AW1SEP66.abbdb085.jpg";